module.exports = __webpack_public_path__ + "media/images/trash3-85ea7d27.svg";